import styled, { css } from 'styled-components';

export const ChartWrapper = styled.div`
  width: 100%;
`;

export const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
`;
